import {
    updateMobileDropdownLabel
} from "../../../instantsearch/Utils";
import {addParamToUrl} from "../../../Utils";
import {hideOrShowPagination} from "./paginationUtils";

const mostRelevantResultsSlug = 'most_relevant_results';
export const handleChangeTab = (slug) => {
    setInactiveAllTabs();
    setActiveTabs(slug);
    activateTab(slug);
    addParamToUrl('content_type', slug);
    hideOrShowPagination(slug);
}

export const setInactiveAllTabs = () =>  {
    hideAllTabsContent();
    setInactiveMobileTabs();
    setInactiveDesktopTabs();
}

export const hideAllTabsContent = () => {
    const allTabsContent = document.querySelectorAll('.tabcontent');
    allTabsContent.forEach(tab => {
        tab.style.display = 'none';
    })
}

export const setInactiveMobileTabs = () => {
    const mobileTabs = document.querySelectorAll('.searcher-tab-filter-js');
    mobileTabs.forEach(tab => {
        tab.classList.remove('selected');
    })
}

export const setInactiveDesktopTabs = () => {
    const desktopTabs = document.querySelectorAll('.tablink');
    desktopTabs.forEach(tab => {
        tab.classList.remove('border-b');
    })
}

export const setActiveTabs = (slug) => {
    const desktopTab = document.querySelector(`.tablink[data-slug="${slug}"]`);
    desktopTab.classList.add('border-b');

    const mobileTab = document.querySelector(`.searcher-tab-filter-js[data-slug="${slug}"]`);
    mobileTab.classList.add('selected');

    updateMobileDropdownLabel(mobileTab);
}

export const activateTab = (slug) => {
    const tabSelectorId = `${slug}_tab`;
    const allTabsContent = document.querySelectorAll('.tabcontent');
    allTabsContent.forEach(tab => {
        tab.style.display = 'none';
    })

    const targetTab = document.getElementById(tabSelectorId);
    if (targetTab) {
        targetTab.style.display = 'block';
    }
}

export const setTabResultsCounter = (slug, total) => {
    const resultCounterElements = document.querySelectorAll(`.results-counter-js[data-slug="${slug}"]`);
    resultCounterElements.forEach((el) => {
        el.textContent = `(${total ?? 0})`;
    });
}

export const showMostRelevantResultsHandler = () => {
    // addParamToUrl('content_type', mostRelevantResultsSlug);
    // handleChangeTab(mostRelevantResultsSlug);

    const mostRelevantResultsEl = document.querySelector('#most_relevant_results_tab');
    if(mostRelevantResultsEl) {
        mostRelevantResultsEl.style.display = "block";
    }

    const mostRelevantResultsTab = document.querySelector(`button[data-slug="${mostRelevantResultsSlug}"]`);
    if(mostRelevantResultsTab) {
        mostRelevantResultsTab.style.display = "block";
    }

    const mostRelevantResultsTabMobile = document.querySelector(`.mobile-tab-item-js[data-slug="${mostRelevantResultsSlug}"]`);
    if(mostRelevantResultsTabMobile) {
        mostRelevantResultsTabMobile.style.display = "block";
    }
}

export const hideMostRelevantResultsHandler = (currentTab) => {
    // handleChangeTab('actions');

    const mostRelevantResultsEl = document.querySelector('#most_relevant_results_tab');
    if (mostRelevantResultsEl) {
        mostRelevantResultsEl.style.display = "none";
    }

    const mostRelevantResultsTab = document.querySelector(`button[data-slug="${mostRelevantResultsSlug}"]`);
    if (mostRelevantResultsTab) {
        mostRelevantResultsTab.style.display = "none";
    }

    const mostRelevantResultsTabMobile = document.querySelector(`.mobile-tab-item-js[data-slug="${mostRelevantResultsSlug}"]`);
    if(mostRelevantResultsTabMobile) {
        mostRelevantResultsTabMobile.style.display = "none";
    }
}